
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-data_object",
  "use": "icon-material-data_object-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-data_object\"><path d=\"M573.59-154.02v-67.89H685.7q21.89 0 37.14-15.13 15.25-15.12 15.25-37.5v-94.5q0-37.24 22.5-66.6t57.98-40.44v-7.84q-35.48-10.08-57.98-39.94t-22.5-67.1v-94.74q0-22.14-15.13-37.26-15.12-15.13-37.26-15.13H573.59v-68.13h118.08q47.8 0 81.17 33.46 33.38 33.46 33.38 81.33v94.5q0 22.44 14.97 37.53 14.97 15.1 37.42 15.1h27.61v128.6h-27.61q-22.45 0-37.42 15.13t-14.97 37.27v94.73q0 47.99-33.46 81.27t-81.09 33.28zm-305.26 0q-47.92 0-81.11-33.28-33.2-33.28-33.2-81.27v-94.73q0-22.14-15.12-37.27-15.13-15.13-37.27-15.13H74.02v-128.6h27.61q22.14 0 37.27-15.1 15.12-15.09 15.12-37.53v-94.5q0-47.87 33.28-81.33t81.03-33.46h118.08v68.13H274.54q-21.89 0-37.26 15.13-15.37 15.12-15.37 37.26v94.74q0 37.24-22.5 67.1t-57.74 39.94v7.84q35.24 11.08 57.74 40.44t22.5 66.6v94.5q0 22.38 15.25 37.5 15.24 15.13 37.38 15.13h111.87v67.89z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-data_object"/>
                </svg>
            );
        };

        Icon.id = "icon-material-data_object";

        export default Icon;
    